var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('div',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.copy()}}},[_vm._v("Kopieren")])])
}
var staticRenderFns = []

export { render, staticRenderFns }